export const catalogOptions = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

export const isExplicitlyHiddenOnline = (value) => (
  value === true || value === 1 || value === "1" || value === "true"
);

export const visibleCategoryOptions = (response) => (
  catalogOptions(response).filter(
    (category) => !isExplicitlyHiddenOnline(category?.is_hide_online_booking),
  )
);

export const visibleSubscriptionOptions = (response) => (
  catalogOptions(response).filter(
    (subscription) => !isExplicitlyHiddenOnline(subscription?.is_subscription_hide_online),
  )
);
